import type {z} from "zod";
import {EditOfferTemplateNoteBody} from "@project/sdk/sales/zod";
import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {noteFieldLabelIds} from "../../../../../../../support/messages/note.messages";

export const editOfferTemplateNoteTitleSchema = requiredStringSchema(
  EditOfferTemplateNoteBody.shape.title,
  noteFieldLabelIds.title,
);
export const editOfferTemplateNoteContentSchema = requiredStringSchema(
  EditOfferTemplateNoteBody.shape.content,
  noteFieldLabelIds.content,
);
export const editOfferTemplateNoteFormSchema = EditOfferTemplateNoteBody.strict().extend({
  title: editOfferTemplateNoteTitleSchema,
  content: editOfferTemplateNoteContentSchema,
});
export type EditOfferTemplateNoteFormPayload = z.output<typeof editOfferTemplateNoteFormSchema>;
export const draftEditOfferTemplateNoteFormSchema = editOfferTemplateNoteFormSchema.partial();
export type DraftEditOfferTemplateNoteFormPayload = z.output<
  typeof draftEditOfferTemplateNoteFormSchema
>;
